module.exports = __webpack_public_path__ + "img/perfektino.7abc5558.png";